import React from 'react';
import { ExtendCSS, Inline } from 'vcc-ui';

const InlineCode: React.FC<{
  children: string;
}> = ({ children }) => <Inline extend={inlineStyle}>{children}</Inline>;

const inlineStyle: ExtendCSS = ({ theme: { baselineSubGrid, color } }) => ({
  borderRadius: 2,
  padding: `1px ${baselineSubGrid}px`,
  background: color.ornament.divider,
  color: color.foreground.primary,
});

export default InlineCode;
